/**
 * eg-how: scroll trigger for the how-it-works step animations.
 *
 * Progressive enhancement only: this module stamps data-eg-anim on each
 * .eg-how root (which arms the CSS initial states), then an
 * IntersectionObserver adds .is-inview once ~30% visible and the CSS
 * transitions run. Without JS the attribute never lands and the section
 * renders fully drawn and static. Under prefers-reduced-motion the
 * attribute is skipped for the same static result.
 */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const arm = () => {
    const roots = document.querySelectorAll('.eg-how:not([data-eg-anim])');
    if (!roots.length) return;
    const io = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio >= 0.3) {
            entry.target.classList.add('is-inview');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: [0.3] }
    );
    roots.forEach((root) => {
      root.setAttribute('data-eg-anim', '');
      io.observe(root);
    });
  };

  arm();
  document.addEventListener('shopify:section:load', arm);
})();
